// /src/components/layout/MobileHeader.js

import React, { useState, useRef, useEffect } from 'react';
import { FaChevronDown } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const MobileHeader = ({ 
  isOpen, 
  setIsOpen, 
  selectedPropertyId, 
  properties, 
  isGuest,
  guestPropertyName,
  onPropertySelect
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const displayName = isGuest 
    ? guestPropertyName 
    : properties.find(p => p._id === selectedPropertyId)?.name;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <>
      <div className="fixed top-0 left-0 right-0 h-14 bg-gray-900 flex items-center justify-between px-4 md:hidden z-40">
        <Link to="/" className="text-xl font-bold text-white">
          {t('auth.common.brandName')}
        </Link>
        
        {isGuest ? (
          <div className="text-white text-sm font-medium">
            {displayName}
          </div>
        ) : (
          <div ref={dropdownRef} className="relative">
            <button
              onClick={() => setIsDropdownOpen(!isDropdownOpen)}
              className="flex items-center space-x-2 bg-gray-800 text-white px-4 py-2 rounded-lg hover:bg-gray-700 transition-colors"
            >
              <span className="max-w-[150px] truncate">
                {displayName || t('chat.selectProperty')}
              </span>
              <FaChevronDown className={`transition-transform duration-200 ${isDropdownOpen ? 'transform rotate-180' : ''}`} />
            </button>
            
            {isDropdownOpen && (
              <div className="absolute right-0 mt-2 w-48 bg-gray-800 rounded-lg shadow-lg overflow-hidden z-50">
                {properties.map(property => (
                  <button
                    key={property._id}
                    className="block w-full text-left px-4 py-3 text-sm text-white hover:bg-gray-700"
                    onClick={() => {
                      onPropertySelect(property._id);
                      setIsDropdownOpen(false);
                    }}
                  >
                    {property.name}
                  </button>
                ))}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Property welcome message */}
      <div className="md:hidden text-center mt-2 mb-4">
        <div className="text-lg text-white">
          {displayName && t('chat.welcomeTo', { propertyName: displayName })}
        </div>
        {/* <p className="text-gray-400 text-sm mt-1">{t('chat.howCanWeHelp')}</p> */}
      </div>
    </>
  );
};

export default MobileHeader;